import dayjs from 'dayjs';
import { IServiceOrder } from 'app/shared/model/service-order.model';
import { IEmployee } from 'app/shared/model/employee.model';
import { WorkStatus } from 'app/shared/model/enumerations/work-status.model';

export interface IWorkOrder {
  id?: number;
  startDate?: dayjs.Dayjs | null;
  endDate?: dayjs.Dayjs | null;
  workStatus?: keyof typeof WorkStatus | null;
  description?: string | null;
  createdTimestamp?: dayjs.Dayjs | null;
  serviceOrder?: IServiceOrder | null;
  owner?: IEmployee | null;
}

export const defaultValue: Readonly<IWorkOrder> = {};
